import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import users from "./modules/users";
import asfs from "./modules/asfs";
import cart from "./modules/cart";
import customers from "./modules/customers";
import repairs from "./modules/repairs";
import accessories from "./modules/accessories";
import issues from "./modules/issues";
import requests from "./modules/requests";
import inventory from "./modules/inventory";
import parts from "./modules/parts";
import documents from "./modules/documents";
import models from "./modules/models";
import assessments from "./modules/assessments";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        users,
        asfs,
        cart,
        customers,
        repairs,
        accessories,
        issues,
        requests,
        inventory,
        parts,
        documents,
        models,
        assessments
    },
    actions: {
        resetAll({
            commit
        }) {
            commit("accessories/clearAll");
            commit("asfs/clearAll");
            commit("cart/clearAll");
            commit("customers/clearAll");
            commit("issues/clearAll");
            commit("repairs/clearAll");
            commit("requests/clearAll");
            commit("users/clearAll");
            commit("inventory/clearAll");
            commit("parts/clearAll");
            commit("documents/clearAll");
            commit("models/clearAll");
            commit("assessments/clearAll");
        }
    }
});
